// DataDetailsDrawer.js

import React, { useState, useEffect } from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Box,
  VStack,
  Button,
  Textarea,
  Flex,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

const DataDetailsDrawer = ({
  isOpen,
  onClose,
  data,
  drawerWidth = '60vw',
  placement = 'right',
  dataDrawerBg = '#023F2E',
  dataDrawerTextColor = '#FFFFFF',
  buttonColorScheme = 'green',
  dataDrawerBoxBg ='black',
  buttonSize = 'lg',
}) => {
  const [notes, setNotes] = useState('');

  // Effect to update notes when the data prop changes
  useEffect(() => {
    if (data) {
      setNotes(data.notes || ''); // Reset notes when new data is received
    }
  }, [data]);

  // Function to render key-value pairs from the data
  const renderDetails = (data) => {
    if (!data || Object.keys(data).length === 0) {
      return <Box>No data available</Box>;
    }
    return Object.entries(data).map(([key, value]) => (
      <Box key={key} mb={2}>
        <strong>{formatKey(key)}:</strong> {value || 'Not available'}
      </Box>
    ));
  };

  // Format keys to a more readable format
  const formatKey = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());
  };

  // Handle save action
  const handleSave = () => {
    console.log('Saving notes:', notes);
    onClose();
  };

  return (
    <Drawer isOpen={isOpen} placement={placement} onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent bg={dataDrawerBg} maxWidth={drawerWidth} minWidth={drawerWidth}>
        <DrawerCloseButton color={dataDrawerTextColor} />
        <DrawerHeader color={dataDrawerTextColor}>Details</DrawerHeader>
        <DrawerBody>
          <VStack spacing={4} align="stretch">
            <Box p={4} bg={dataDrawerBoxBg} color={dataDrawerTextColor} borderRadius="8px">
              <Box fontSize="18px" fontWeight="700" mb={2}>
                Details:
              </Box>
              {renderDetails(data)}
            </Box>
            <Box p={4} bg={dataDrawerBoxBg} color={dataDrawerTextColor} borderRadius="8px">
              <Box fontSize="18px" fontWeight="700" mb={2}>
                Notes:
              </Box>
              <Textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Add your notes here..."
                bg={dataDrawerBoxBg}
                color={dataDrawerTextColor}
                resize="none"
                border="none"
              />
            </Box>
            <Flex justifyContent="flex-end">
              <Button colorScheme={buttonColorScheme} size={buttonSize} onClick={handleSave}>
                Save
              </Button>
            </Flex>
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

DataDetailsDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object,
  drawerWidth: PropTypes.string,
  placement: PropTypes.oneOf(['left', 'right']),
  dataDrawerBg: PropTypes.string,
  dataDrawerTextColor: PropTypes.string,
  dataDrawerBoxBg: PropTypes.string,
  buttonColorScheme: PropTypes.string,
  buttonSize: PropTypes.oneOf(['sm', 'md', 'lg']),
};


export default DataDetailsDrawer;
